<template>
  <div class="">
    <el-form
      ref="form"
      :model="form"
      label-width="120px"
    >
      <el-form-item label="客服名称">
        <el-input v-model="form.customer_name" />
      </el-form-item>

      <el-form-item label="客户二维码">
        <!-- <div v-if="!form.qrcode_img" class="erBox" @click="$refs.file.click()">
          <input ref="file" type="file" class="file" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg" @change="uploadQRCode">
        </div> -->
        <el-upload
          v-if="!form.qrcode_img"
          ref="upload"
          class="upload-demo"
          action="#"
          :http-request="httpRequest"
          :multiple="true"
          :show-file-list="false"
          :limit="100"
          accept="image/*"
        >
          <el-button
            size="small"
            type="primary"
            plain
          >点击上传</el-button>
        </el-upload>
        <div
          v-else
          class="imgBox"
        >
          <img
            :src="form.qrcode_img"
            style="width: 100px; height: 100px;"
          >
          <span>
            <i
              class="el-icon-error myi"
              @click="form.qrcode_img = null"
            />
          </span>
        </div>
      </el-form-item>

      <el-form-item label="企业">
        <el-select
          v-model="form.company_id"
          placeholder="请选择企业"
        >
          <el-option
            v-for="item in enterprises"
            :key="item.id"
            :label="item.corpName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          @click="onSubmit"
        >立即创建</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import * as qiniu from 'qiniu-js'
import { qiniuToken } from '@/api/qiniuToken.js'
import { enterpriseMicro } from '@/api/providerAccountManagement/servicePorviderList.js'
import getNowDate from '@/utils/mixins/convertToHump.js'
import { uploadFilesimg } from '@/utils/ObjectStorage.js'
import { getQcConfig } from '@/api/sourceminiprogram.js'
export default {
  mixins: [getNowDate],
  props: {
    currentItem: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      form: {
        customer_name: this.currentItem.customer_name, // 客服名称
        company_id: this.currentItem.company_id, // 企业id
        qrcode_img: this.currentItem.qrcode_img // 二维码
      },
      token: null,
      enterprises: [],
      config: {}
    }
  },
  async created() {
    // this.getQiniuToken()
    this.getconfig()
    const data = await enterpriseMicro()
    this.enterprises = data.data
  },
  methods: {
    onSubmit() {
      this.judge() && this.$emit('determine', { ...this.form, qrcode_img: this.form.qrcode_img.slice(30) })
    },

    judge() {
      let text = null
      if (!this.form.customer_name) {
        text = '请输入客服名称'
      } else if (!this.form.company_id) {
        text = '请选择企业'
      } else if (!this.form.qrcode_img) {
        text = '请上传二维码'
      }

      text &&
        this.$message({
          message: text,
          type: 'warning'
        })

      return !text
    },

    uploadQRCode(event) {
      const fileIfon = event.target.files[0]
      // const img = new Image()
      const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
      const extension = ftype === '.jpg'
      const extension2 = ftype === '.png'
      const extension3 = ftype === '.jpeg'
      const extension4 = ftype === '.gif'
      // eslint-disable-next-line eqeqeq
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
          type: 'error'
        })
        return
      }
      const observable = qiniu.upload(
        fileIfon,
        `detectEnterpriseWeChat/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`,
        this.token,
        {
          fname: fileIfon.name // 文件名
        },
        {
          useCdnDomain: true // cdn域名加速
        }
      )
      observable.subscribe({
        next() {},
        error(err) {
          console.log(err)
        },
        complete: data => {
          this.form.qrcode_img = 'https://ziyuan.jingxuansz.com/' + data.key
        }
      })
    },

    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },
    async getconfig() {
      const res = await getQcConfig()
      this.config = res.data
    },
    async httpRequest(e) {
      // console.log('e:', e)
      const _this = this
      const fileIfon = e.file
      console.log('fileIfon:', fileIfon)
      // eslint-disable-next-line no-unused-vars
      const arr = []
      const img = new Image()
      // const videoWidth = 0
      // const videoHeight = 0
      const fileType = fileIfon.type
      console.log('fileType:', fileType)

      if (fileType.startsWith('image/')) {
        // const temporary = e.files.length > 1 ? '多张' : window.URL.createObjectURL(fileIfon)
        // temporary !== '多张' && (img.src = temporary)
        // this.temporary = temporary
        const programimg = window.URL.createObjectURL(fileIfon)
        img.src = programimg
        const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
        const extension = ftype === '.jpg'
        const extension2 = ftype === '.png'
        const extension3 = ftype === '.jpeg'
        const extension4 = ftype === '.gif'
        // eslint-disable-next-line eqeqeq
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
            type: 'error'
          })
          return
        }
        console.log('fileIfon.size:', fileIfon.size)
        const maxSize = 20 * 1024 * 1024 // 设置最大文件大小为50MB
        if (fileIfon.size > maxSize) {
          return this.$message('上传图片太大')
        }
        _this.showProgress = true
        this.percentage = 0
        console.log('fileIfon:', fileIfon)
        await uploadFilesimg(
          fileIfon,
          (num, id) => {
            this.percentage = num
          },
          'operation',
          this.config
        )
          .then(res => {
            // console.log('res-------:', res.files[0].options, this.config.domain)
            // this.updataimg = this.config.domain + res.files[0].options.Key
            // this.cover = res.files[0].options.Key
            this.form.qrcode_img = this.config.domain + res.files[0].options.Key
          })
          .catch(err => {
            console.log('err:-----', err)
          })
      } else {
        this.$message({
          message: '不支持的文件类型',
          type: 'error'
        })
      }
    }
  }
}
</script>

<style scoped>
.erBox {
  width: 100px;
  height: 100px;
  border: 1px solid #ccc;
  cursor: pointer;
  position: relative;
}

.erBox::before {
  content: '';
  position: absolute;
  width: 1px;
  height: 50px;
  background-color: #ccc;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.erBox::after {
  content: '';
  position: absolute;
  width: 50px;
  height: 1px;
  background-color: #ccc;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.erBox:hover {
  border-color: rgb(7, 123, 201);
}

.erBox:hover::after,
.erBox:hover::before {
  background-color: rgb(7, 123, 201);
}

.file {
  display: none;
}

.imgBox {
  width: 100px;
  height: 100px;
  position: relative;
}

.imgBox:hover span {
  display: inline-block !important;
}

.imgBox span {
  width: 100%;
  height: 100%;
  background-color: rgba(200, 200, 200, 0.5);
  position: absolute;
  z-index: 11;
  left: 0px;
  display: none;
}

.myi {
  cursor: pointer;
  font-size: 25px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
